<template>
  <el-dialog :visible="innerVisible" :title="$t('Sop.sift')" width="1000px" :show-close="false" @open="open">
    <el-form label-position="right" label-width="80px">
      <el-row :gutter="5">
        <el-col :span="8">
          <el-form-item :label="$t('queryJob.businessType')">
            <cargo-advance-select
              select-type="local_cache_SystemConstants$LOBS"
              filterable
              :placeholder="' '"
              callback-method-type="value"
              :multiple="true"
              :default-multiple-value="jobLobs"
              @parentCallBack="cascadeCallBack"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$t('Sop.nodeState')">
            <el-dropdown trigger="click" placement="bottom-start" @visible-change="onChangePushNode">
              <span class="el-dropdown-link">
                <el-input v-model="search.pushNodeTxt" :readonly="true" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <cargo-ag-grid
                  :show-side-bar="false"
                  :grid-options="pushNodeTree.gridOptions"
                  :column-defs="pushNodeTree.columnDefs"
                  :row-data="pushNodeTree.rowData"
                  style="width:100%;height:100%;"
                  @gridReady="onGridReady"
                />
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>
        </el-col>
        <el-col v-for="(item,index) in searchForm" v-if="item.key !== 'lob' && item.key !== 'trackDetailIds'" :key="`${item.key}${index}`" :span="8">
          <el-form-item :label="$t(item.label)">
            <cargo-advance-select
              v-if="item.type==='cargoAdvanceSelect'"
              :default-value="item.props.multiple ? '' : item.value"
              v-bind="item.props"
              style="width: 100%"
              @parentCallBack="p=>item.value=p.value"
            />
            <component :is="item.type" v-else v-model="item.value" v-bind="item.props" style="width: 100%" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <template slot="footer">
      <el-button type="primary" @click="handleFilter">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button @click="restForm">{{ $t('SeaExport.Cancel') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getPushNodeTree } from '@/api/sopEmailRecord'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'FilterDialog',
  components: { CargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      configContent: '',
      searchForm: [
        {
          key: 'jobNo',
          label: 'SeaExport.BusinessNo',
          type: 'el-input',
          value: ''
        }, {
          key: 'mbl',
          label: 'queryJob.mblNo',
          type: 'el-input',
          value: ''
        }, {
          key: 'warnLevel',
          label: 'Sop.warningLevel',
          type: 'cargoAdvanceSelect',
          value: '',
          props: {
            cache: false,
            staticOptions: null,
            tagValue: 'code'
          }
        }, {
          key: 'etd',
          label: 'ETD',
          type: 'el-date-picker',
          value: '',
          props: {
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd'
          }
        }, {
          key: 'eta',
          label: 'ETA',
          type: 'el-date-picker',
          value: '',
          props: {
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd'
          }
        }, {
          key: 'createTime',
          label: 'Sop.warningAt',
          type: 'el-date-picker',
          value: '',
          props: {
            type: 'daterange',
            valueFormat: 'yyyy-MM-dd'
          }
        }, {
          key: 'vessel',
          label: 'queryJob.vessel',
          type: 'el-input',
          value: '',
          props: {
            selectType: 'static_data_Vessel',
            cache: false,
            staticOptions: null
          }
        }, {
          key: 'voyageFlight',
          label: 'queryJob.voyageFlight',
          type: 'el-input',
          value: ''
        }
      ],
      jobLobs: [],
      search: {
        pushNode: [],
        pushNodeTxt: ''
      },
      gridApi: null,
      nodeTree: [],
      pushNodeTree: {
        gridOptions: {},
        columnDefs: null,
        rowData: []
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      }
    }
  },
  created() {
    this.getNodeTree()
    this.initAgGird()
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    // 业务类型-节点名称-节点状态级联
    getNodeTree() {
      getPushNodeTree().then(res => {
        if (res.code === '0') {
          const result = res.data
          this.nodeTree = result.treeList
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    cascadeCallBack(backVal) {
      this.jobLobs = backVal
      if (this.jobLobs.length > 0) {
        let result = []; const list = []
        for (let i = 0; i < this.jobLobs.length; i++) {
          this.nodeTree.forEach(node => {
            if (this.jobLobs[i] === node.uuid) {
              list.push(node.uuid)
              result.push(node)
            }
          })
        }
        result = [...result, ...this.handleNodeData(list)]
        this.gridApi.setRowData(result)
        this.initSelectedRow()
      } else {
        this.search.pushNode = []
        this.search.pushNodeTxt = ''
      }
    },
    // 递归处理子节点数据
    handleNodeData(childNode) {
      const result = []
      childNode.forEach(node => {
        this.nodeTree.forEach(event => {
          if (event.path.indexOf(node) > -1) {
            result.push(event)
          }
        })
      })
      return result
    },
    onChangePushNode(isShow) {
      if (!isShow) {
        const isZh = this.$store.getters.isZh
        const rows = this.gridApi.getSelectedRows()
        const nodeMap = new Map()
        const pushNode = []
        const pushNodeTxt = []
        rows.forEach(row => {
          pushNode.push(row.uuid)
          pushNodeTxt.push(isZh ? row.chineseName : row.englishName)
          nodeMap.set(row.code, isZh ? row.chineseName : row.englishName)
        })

        this.search.pushNode = pushNode
        this.search.pushNodeTxt = pushNodeTxt.join(',')
      }
    },
    initAgGird() {
      this.pushNodeTree.columnDefs = []
      this.pushNodeTree.gridOptions = {
        rowSelection: 'multiple',
        groupDefaultExpanded: 0,
        suppressRowClickSelection: false,
        treeData: true,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('SeaExport.Name'),
          width: 320,
          valueFormatter: (params) => {
            if (params.data.code) {
              // return `[${params.data.code}]` + params.data.chineseName
              return this.$store.getters.isZh ? params.data.chineseName : params.data.englishName
            } else {
              return this.$store.getters.isZh ? params.data.chineseName : params.data.englishName
            }
          },
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: (params) => {
              return params.data.type === 3
            }
          }
        }
      }
    },
    async getFilterConfig() {
      if (this.configContent !== '') {
        this.searchForm = JSON.parse(this.configContent)
      } else {
        this.configContent = JSON.stringify(this.searchForm)
      }
      this.searchForm.map(eve => {
        if (eve.key === 'lob' && eve.value.length === 0) {
          this.jobLobs = []
        }
        if (eve.key === 'trackDetailIds' && eve.value.length === 0) {
          this.search.pushNode = []
          this.search.pushNodeTxt = ''
        }
      })
      this.initSelectedRow()
      await this.initOptions()
    },
    async initOptions() {
      const warnLevel = this.searchForm.find(item => item.key === 'warnLevel')
      warnLevel.props.staticOptions = [
        {
          chineseName: '最高',
          code: 0,
          englishName: 'Highest'
        },
        {
          chineseName: '高',
          code: 1,
          englishName: 'High'
        },
        {
          chineseName: '中',
          code: 2,
          englishName: 'Medium'
        },
        {
          chineseName: '低',
          code: 3,
          englishName: 'Low'
        }
      ]
      // const vesselList = await loadSpecificBasicInfo('Vessel')
      // const vessel = this.searchForm.find(item => item.key === 'vessel')
      // vessel.props.staticOptions = vesselList.data
    },
    handleFilter() {
      this.onChangePushNode()
      // 业务类型处理
      if (this.jobLobs.length > 0) {
        let hasLob = false
        this.searchForm.map(event => {
          if (event.key === 'lob') {
            hasLob = true
            const jobLobsTxt = []
            this.jobLobs.map(e => {
              jobLobsTxt.push(ColumnUtils.jobBussStateLabelFunc(e))
            })
            event.name = jobLobsTxt.join(',')
            event.value = this.jobLobs
          }
        })
        if (!hasLob) {
          const jobLobsTxt = []
          this.jobLobs.map(e => {
            jobLobsTxt.push(ColumnUtils.jobBussStateLabelFunc(e))
          })
          this.searchForm.unshift({
            key: 'lob',
            name: `${jobLobsTxt.join(',')}`,
            label: 'queryJob.businessType',
            value: this.jobLobs
          })
        }
      } else {
        this.searchForm.map((event, index) => {
          if (event.key === 'lob') {
            this.searchForm.splice(index, 1)
          }
        })
        this.search.pushNode = []
        this.search.pushNodeTxt = ''
      }
      // 节点提交处理
      if (this.search.pushNode.length > 0) {
        let hasLob = false
        this.searchForm.map(event => {
          if (event.key === 'trackDetailIds') {
            hasLob = true
            event.value = this.search.pushNode
            event.name = this.search.pushNodeTxt
          }
        })
        if (!hasLob) {
          this.searchForm.push({
            key: 'trackDetailIds',
            value: this.search.pushNode,
            label: 'Sop.nodeState',
            name: this.search.pushNodeTxt
          })
        }
      } else {
        this.searchForm.map((event, index) => {
          if (event.key === 'trackDetailIds') {
            this.searchForm.splice(index, 1)
          }
        })
      }
      this.configContent = JSON.stringify(this.searchForm)
      this.$emit('search', this.searchForm.filter(item => item.value || item.value === 0), this.configContent)
    },
    restForm() {
      this.searchForm = JSON.parse(this.configContent)
      this.searchForm.map(events => {
        if (events.key === 'trackDetailIds') {
          this.search.pushNode = events.value
          this.search.pushNodeTxt = events.name
        }
        if (events.key === 'lob') {
          this.jobLobs = events.value
        }
      })

      this.innerVisible = false
    },
    initSelectedRow() {
      let selectRows = []
      this.searchForm.map(eve => {
        if (eve.key === 'trackDetailIds') {
          selectRows = eve.value
        }
      })
      if (this.gridApi && selectRows.length > 0) {
        this.gridApi.forEachNode(node => {
          selectRows.map(event => {
            if (event === node.data.uuid) {
              this.gridApi.selectNode(node, true)
            }
          })
        })
      } else if (this.gridApi && selectRows.length === 0) {
        this.gridApi.selectAll()
        this.gridApi.deselectAll()
      }
    },
    open() {
      this.getFilterConfig()
    },
    configChange(configContent) {
      this.configContent = configContent
    }
  }
}
</script>

<style lang="scss" scoped>
.el-row{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.el-dropdown{
  width: 100%;
}
.el-dropdown-menu{
  width: 323.325px;
}
</style>
